import { render } from "./BillingInvoices.vue?vue&type=template&id=db69481c&scoped=true"
import script from "./BillingInvoices.vue?vue&type=script&lang=js"
export * from "./BillingInvoices.vue?vue&type=script&lang=js"

import "./BillingInvoices.vue?vue&type=style&index=0&id=db69481c&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db69481c"]])

export default __exports__